window.LINKEDIN_ICON = new URL('../icons/linkedin.svg', import.meta.url).href;
window.INSTAGRAM_ICON = new URL('../icons/instagram.svg', import.meta.url).href;
window.TIKTOK_ICON = new URL('../icons/tiktok.svg', import.meta.url).href;
window.YOUTUBE_ICON = new URL('../icons/youtube.svg', import.meta.url).href;
window.WHATSAPP_ICON = new URL('../icons/whatsapp.svg', import.meta.url).href;
window.MESSENGER_ICON = new URL('../icons/messenger.svg', import.meta.url).href;
window.FACEBOOK_ICON = new URL('../icons/facebook.svg', import.meta.url).href;
window.THREADS_ICON = new URL('../icons/threads.svg', import.meta.url).href;
window.SUCCESS_ICON = new URL('../icons/success-icon.svg', import.meta.url).href;
window.INCORRECT_ICON = new URL('../icons/incorrect-icon.svg', import.meta.url).href;
window.WHITE_SYNC_ICON = new URL('../icons/sync-white.svg', import.meta.url).href;
window.BLACK_SYNC_ICON = new URL('../icons/sync-black.svg', import.meta.url).href;

const GRAY_ICON = 'https://cdn.hyperdev.com/us-east-1%3A3d31b21c-01a0-4da2-8827-4bc6e88b7618%2Ficon-gray.svg';
import axios from "axios";
const onDone = () => {
    console.log('on done')
}
const syncToThisBoard =  (t, opts) => {
    return t.popup({
        callback: onDone,
        title: 'Sync Socials to the Board',
        url: './sync-socials.html',
        height: 350
    })

};
window.TrelloPowerUp.initialize({
    'authorization-status': (t, options) => {
        // return a promise that resolves to the object with
        // a property 'authorized' being true/false
        // you can also return the object synchronously if you know
        // the answer synchronously
        return t.member('id', 'fullName')
            .then((member) => {
                return axios.post('https://social.businessstorylab.com/api/trello-login',
                    {trelloMemberId: member.id, trelloUserName: member.fullName})
                    .then((response) => {
                        return {authorized: response.data}
                    })
            })
    },
    'show-authorization': (t, options) => {
        // return what to do when a user clicks the 'Authorize Account' link
        // from the Power-Up gear icon which shows when 'authorization-status'
        // returns { authorized: false }
        // in this case we would open a popup
        return t.popup({
            title: 'My Auth Popup',
            url: './sign-up.html',
            height: 140,
        });
    },
    'board-buttons': (t, opts) => {
        return [{
            icon: {
                dark: window.WHITE_SYNC_ICON,
                light: window.BLACK_SYNC_ICON
            },
            text: 'Sync to this board',
            callback: syncToThisBoard,
            condition: 'edit'
        }];
    },
    //additional card data ->  'dateLastActivity', 'due', 'dueComplete', 'name', 'url', 'desc', 'shortLink'
    'card-badges': (t, ops) => {
        return t.card('id')
            .then((card) => {
                return t.member('id').then((member) => {
                    axios.defaults.headers.common['BSL-Social-Token'] = process.env.SOCIALS_TOKEN
                    return axios.get('https://social.businessstorylab.com/api/social/posts-by-card', {
                        params: {
                            foreignUserId: member.id, cardId: card.id
                        }
                    }).then((response) => {
                        if (response.data) {
                            let badges = []
                            response.data.forEach((post) => {
                                let iconName = post.platform.toUpperCase() + '_ICON'
                                badges.push({
                                    text: post.status,
                                    icon: window[iconName],
                                    monochrome: false
                                })
                            })
                            return badges
                        }
                    })
                })

            })
    },
    'card-back-section': (t, options) => {
        return t.card('id').then((card) => {
            return t.member('id', 'fullName').then(async (member) => {
                let authorized = await axios.post('https://social.businessstorylab.com/api/trello-login',
                    {trelloMemberId: member.id, trelloUserName: member.fullName})
                    .then((response) => {
                        return response.data
                    })
                if (authorized === true) {
                    return {
                        title: 'Automate Socials',
                        icon: GRAY_ICON, // Must be a gray icon, colored icons not allowed.
                        content:
                            {
                                type: 'iframe',
                                url: t.signUrl(`./section.html?trello-member-id=${member.id}&trello-member-name=${member.fullName}&trello-card-id=${card.id}`),
                                height: 350, // Max height is 1500.
                            },
                        /*action: {
                            text: 'My Action',
                            callback: (t) => t.popup(...),
                        }*/
                    };
                } else {
                    return {
                        title: 'Automate Socials',
                        icon: GRAY_ICON, // Must be a gray icon, colored icons not allowed.
                        content:
                            {
                                type: 'iframe',
                                url: t.signUrl(`./sign-up.html`),
                                height: 230, // Max height is 1500.
                            }
                    }
                }
            })
        })

    }
});